import HTTPService from '@/services/httpService';
import { Inject, Service } from 'vue-di-container';

import { UserModel } from '@/models/user';

@Service()
export default class UserService {
  @Inject(HTTPService) private httpService!: HTTPService;

  public async getUser(): Promise<UserModel | any> {
    try {
      const url = 'api/UserInfo';
      const result = await this.httpService.httpInstance.get<UserModel>(url);

      return result.data;
    } catch (exception) {
      return null;
    }
  }
}
